import { firebaseDb } from "../../firebase";
import * as actionTypes from "./actionTypes";

export const getActivitiesStart = () => {
  return {
    type: actionTypes.GET_ACTIVITIES_START,
  };
};

export const getActivitiesSuccess = (userActivities) => {
  return {
    type: actionTypes.GET_ACTIVITIES_SUCCESS,
    userActivities: userActivities,
    success: true,
  };
};

export const getActivitiesFinish = () => {
  return {
    type: actionTypes.GET_ACTIVITIES_FINISH,
    success: false,
  };
};

export const getActivitiesFail = (error) => {
  return {
    type: actionTypes.GET_ACTIVITIES_FAIL,
    error: error,
  };
};

export const getActivities = (userId) => {
  let userActivities = [];
  return (dispatch) => {
    dispatch(getActivitiesStart());

    firebaseDb
      .collection("User_Event")
      .where("userId", "==", userId)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let userActivity = { id: doc.id, data: doc.data() };
          userActivities.push(userActivity);
        });
      })
      .then(() => {
        dispatch(getActivitiesSuccess(userActivities));
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);
      });
  };
};
